var symphony = symphony || {};

;(function() {

  symphony.localNeedsScroll = function() {


	var controller = new ScrollMagic.Controller();

	new ScrollMagic.Scene({
        duration: $(window).height(),  // the scene should last for a scroll distance of 100px
        offset: 50      // start this scene after scrolling for 50px
    })
    .setPin(".icon-magnifying-glass") // pins the element for the the scene's duration
    .addTo(controller); // assign the scene to the controller

    console.log(controller);

  };


})();